import { EP_PRODUCTION_URL } from '../constants';

export function redirectToProd(url = '') {
  window.location.href = EP_PRODUCTION_URL + url;
}

export function buildProdUrl(url = '') {
  return EP_PRODUCTION_URL + url;
}
